import { useLoaderData } from "react-router-dom";
import {
  Pagewrapper,
  LeftSection,
  VerticalSlider,
  SliderDepth,
  DssModal,
} from "./style";
import { useEffect, useRef, useState } from "react";
import { gettreeStruct } from "./utils";
import { Background } from "./components/Background";
import { InfoSection } from "./components/InfoSection";
import { History } from "./components/History";
import { TreeWizard } from "./components/TreeWizard";
import { ChatWrapper } from "./components/ChatWrapper";
import { DssSocket } from "../../calls/socket/dss.socket";

const dssSocket = new DssSocket();
export const HISTORY_CARD_SLIDE_ANIMATION_DURATION_MSEC = 2000;
const currentLang = window.localStorage.getItem("comanage_dss_lang") || "eng";
export const DssPage = () => {
  const { treeDssStruct, params, languages, dssInfoSection } = useLoaderData();
  const currentInfoSection = dssInfoSection.find((d) => d.lang === currentLang);
  const [history, setHistory] = useState([]);
  const [conversation, setConversation] = useState([
    { left: false, body: currentInfoSection?.dss_chat_first_message },
  ]);
  const [cleanHistory, setCleanHistory] = useState(false);
  const [targetPosition, setTargetPosition] = useState([0, 0]);
  const [chatConfig, setChatConfig] = useState(null);
  const [modalData, setModalData] = useState(null);
  const [loading, setLoading] = useState(false);
  const wrapperref = useRef();
  const windowref = useRef();

  const onChatMessage = (message) => {
    setConversation((prev) => [...prev, { text: message, left: true }]);
    setLoading(true);
    dssSocket.askQuestion(message);
  };

  const putElementOnCenter = (node, preventHistory) => {
    const { position } = node;
    const targetid = "g" + position;
    const target = document.getElementById(targetid);
    if (!preventHistory) {
      const currentHistory = history;
      const newHistory = [
        ...currentHistory,
        {
          ...node,
          chartPosition: targetPosition,
          toRemove: false,
        },
      ];
      setHistory(newHistory);
    }
    if (!target) {
      setChatConfig(position);
      return;
    }
    const targetCurrentPosition = target.getBoundingClientRect();
    const wrapperPosition = wrapperref.current.getBoundingClientRect();
    const windowDimension = windowref.current.getBoundingClientRect();
    const newPosition = [
      targetCurrentPosition.y -
      wrapperPosition.y +
      targetCurrentPosition.height * 0.5 -
      windowDimension.height * 0.5,
      targetCurrentPosition.x -
      wrapperPosition.x +
      targetCurrentPosition.width * 0.5 -
      windowDimension.width * 0.5,
    ];

    setTargetPosition(newPosition);
  };

  useEffect(() => {
    putElementOnCenter({ position: "" }, true);
    document.getElementById("dsspagecta").click();
  }, []);

  dssSocket.waitAnswer("dss_page", (text, pages) => {
    setConversation((prev) => [
      ...prev,
      {
        text,
        left: false,
        references: pages,
      },
    ]);
    setLoading(false);
  });

  const layers = gettreeStruct(
    treeDssStruct.filter((card) => card.lang === currentLang)
  );

  if (cleanHistory) {
    const nodesToRemove = history.filter(({ toRemove }) => toRemove);
    if (nodesToRemove) {
      setTimeout(() => {
        const cleanedHistory = history.filter(({ toRemove }) => !toRemove);
        setHistory(cleanedHistory);
        setCleanHistory(false);
      }, HISTORY_CARD_SLIDE_ANIMATION_DURATION_MSEC - 10);
    }
  }

  const openModal = (data) => {
    setModalData(data);
  };

  const columnHeaders = dssInfoSection.find(
    (d) => d.lang === currentLang
  ).colums_headers;
  return (
    <>
      <button
        style={{ visibility: "collapse" }}
        id="dsspagecta"
        className={`dsspage dsspage${currentLang}`}
      />
      <div>
        {false ? currentInfoSection.title : ""}
        <Background />
      </div>
      <Pagewrapper
        style={{
          "--animation-history-card-timing": `${HISTORY_CARD_SLIDE_ANIMATION_DURATION_MSEC / 1000
            }s`,
        }}
      >
        <LeftSection>
          <InfoSection
            languages={dssInfoSection.map((d) =>
              languages.find((l) => l.id === d.lang)
            )}
            data={dssInfoSection.find((d) => d.lang === currentLang)}
            currentLang={currentLang}
            onLangIconClick={({ id }) => {
              window.localStorage.setItem("comanage_dss_lang", id);
              window.location.reload();
            }}
          />
          <History
            oncCardClick={(node, index) => {
              setTargetPosition(node.chartPosition);
              const historyToClean = history.map((node, i) => ({
                ...node,
                toRemove: i >= index,
              }));
              setHistory(historyToClean);
              setCleanHistory(true);
              setChatConfig(null);
              setConversation([
                {
                  left: false,
                  body: currentInfoSection?.dss_chat_first_message,
                },
              ]);
            }}
            history={history}
          />
        </LeftSection>
        <VerticalSlider>
          <SliderDepth slideDown={!!chatConfig}>
            <TreeWizard
              {...{
                putElementOnCenter,
                windowref,
                layers,
                targetPosition,
                wrapperref,
                chatConfig,
                history: history,
                setHistory,
              }}
            />
            <ChatWrapper
              {...{
                docHeaderInfo: columnHeaders,
                conversation,
                onChatMessage,
                loading,
                openModal,
              }}
            />
          </SliderDepth>
        </VerticalSlider>
      </Pagewrapper>
      {modalData && (
        <DssModal.Background>
          <DssModal.Wrapper>
            <DssModal.CloseButton onClick={() => setModalData(null)}>
              x
            </DssModal.CloseButton>
            <DssModal.Title
              onClick={() =>
                window.open(modalData.redirectPath, "_blank").focus()
              }
            >
              <DssModal.FileName>
                {modalData.filename}
              </DssModal.FileName>
            </DssModal.Title>
            <DssModal.Row
              style={{
                backgroundColor: "var(--comanage-purple)",
                color: "var(--comanage-green-2)",
              }}
            >
              <DssModal.Content>{columnHeaders.reference}</DssModal.Content>
              <DssModal.Page>{columnHeaders.pages}</DssModal.Page>
            </DssModal.Row>
            {modalData.pages.map(({ page, chunk }, key) => (
              <DssModal.Row
                key={key}
                style={
                  key === modalData.pages.length - 1
                    ? { border: "var(--border-setup)" }
                    : {}
                }
              >
                <DssModal.Content>"{chunk}"</DssModal.Content>
                <DssModal.Page>{page}</DssModal.Page>
              </DssModal.Row>
            ))}
          </DssModal.Wrapper>
        </DssModal.Background>
      )}
      {false ? (
        <pre
          style={{
            position: "fixed",
            top: "2vh",
            width: "2vw",
            zIndex: 100,
            color: "red",
            fontSize: "1vw",
            backgroundColor: "rgba(255,255,255,0.2)",
          }}
        >
          {JSON.stringify({ loading }, null, "\t")}
        </pre>
      ) : (
        ""
      )}
    </>
  );
};
